import { Expose, Type } from 'class-transformer';
import _ from 'lodash';

import { SnModel } from '@lib/common/models';
import { FsFormatDatePipe } from '@lib/common/pipes';

import { IChartData } from '../interfaces';
import { LprCount } from './lpr-count.model';

export class LprStats extends SnModel {
  public mode: string = '';
  private _dailyLprCount: LprCount[] = [];

  private _dailyLprCountChartData: IChartData[] = [];
  private _hourlyLprCountChartData: IChartData[] = [];

  constructor(data: any = {}, mode: string) {
    super();
    this.mode = mode;
    this.fromJSON(data);
  }

  @Expose({ name: 'results' })
  @Type(() => LprCount)
  set dailyLprCount(value: LprCount[]) {
    this._dailyLprCount = value || [];
    this._dailyLprCountChartData = this._dailyLprCount.map((dailyLprCount) =>
      dailyLprCount.chartData(this.mode),
    );
  }

  get dailyLprCount(): LprCount[] {
    return this._dailyLprCount;
  }

  get dailyLprCountChartData(): IChartData[] {
    return this._dailyLprCountChartData;
  }

  get hourlyLprCountChartData(): IChartData[] {
    return this._hourlyLprCountChartData;
  }

  public getData(mode: string): IChartData[] {
    switch (mode) {
      case 'daily':
        this.transformDailyData();
        return this._dailyLprCountChartData;
      case 'hourly':
        this.transformHourlyData();
        return this._hourlyLprCountChartData;
    }
  }

  public transformDailyData(): void {
    const dailyTotals = _(this._dailyLprCountChartData)
      .groupBy('name')
      .map((value, name) => ({
        name,
        value: _.sumBy(value, 'value'),
      }))
      .value();

    const formatData = dailyTotals.reverse();
    this._dailyLprCountChartData = formatData;
  }

  public transformHourlyData(): void {
    const hourlyTotals = _(this._dailyLprCountChartData)
      .groupBy((value) => {
        return new Date(value.name).toDateString();
      })
      .map((value, name) => ({
        name: new FsFormatDatePipe().transform(new Date(name), 'mediumDate'),
        value: _.sumBy(value, 'value'),
      }))
      .value();

    const formatData = hourlyTotals.reverse();
    this._hourlyLprCountChartData = formatData;
  }
}
